// A thin wrapper for $.ajax that knows how to handle requests and responses from the Lomi API
class LomiApiClient {
    constructor() {
      // Production: 'https://api.lomi-app.net'
      // Staging: 'https://api-staging.lomi-app.net'
      this.apiBaseUrl = 'https://api.lomi-app.net';
    }

    // eg. registrations?userId=7fh38fnvc0
    get(path, onSuccess, onError, authToken) {
        $.ajax({
            url: `${this.apiBaseUrl}/${path}`,
            type: 'GET',
            dataType: 'json',
            headers: getLomiApiHeaders(authToken),
            success: (parsedBody) => onSuccess(parsedBody.result),
            error: (jqXHR) => onError(mapJqxhrLomiApiError(jqXHR))
        });
    }

    post(path, body, onSuccess, onError, authToken) {
        $.ajax({
            url: `${this.apiBaseUrl}/${path}`,
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(body),
            headers: getLomiApiHeaders(authToken),
            success: (parsedBody) => onSuccess(parsedBody.result),
            error: (jqXHR) => onError(mapJqxhrLomiApiError(jqXHR))
        });
    }

    put(path, body, onSuccess, onError, authToken) {
        $.ajax({
            url: `${this.apiBaseUrl}/${path}`,
            type: 'PUT',
            dataType: 'json',
            data: JSON.stringify(body),
            headers: getLomiApiHeaders(authToken),
            success: (parsedBody) => onSuccess(parsedBody.result),
            error: (jqXHR) => onError(mapJqxhrLomiApiError(jqXHR))
        });
    }

    patch(path, body, onSuccess, onError, authToken) {
        $.ajax({
            url: `${this.apiBaseUrl}/${path}`,
            type: 'PATCH',
            dataType: 'json',
            data: JSON.stringify(body),
            headers: getLomiApiHeaders(authToken),
            success: (parsedBody) => onSuccess(parsedBody.result),
            error: (jqXHR) => onError(mapJqxhrLomiApiError(jqXHR))
        });
    }

    delete(path, onSuccess, onError, authToken) {
        $.ajax({
            url: `${this.apiBaseUrl}/${path}`,
            type: 'DELETE',
            dataType: 'json',
            headers: getLomiApiHeaders(authToken),
            success: (parsedBody) => onSuccess(parsedBody.result),
            error: (jqXHR) => onError(mapJqxhrLomiApiError(jqXHR))
        });
    }
}

const mapJqxhrLomiApiError = (jqXHR) => {
    /*
        Error shape
        {
            userErrorMessage: string,
            reason: string | undefined,
            status: number | undefined,
            isUnauthorized: () => boolean,
            isNotFound: () => boolean
        }
    */
    let parsedBody = {};
    try {
        parsedBody = jqXHR.responseText ? JSON.parse(jqXHR.responseText) : {};
    } catch (error) {
        // Swallow parsing errors
        console.error(`Error parsing "${jqXHR.responseText}"`, error);
    }
    const fallbackError = jqXHR.status > 0
        ? jqXHR.status
        : jqXHR.readyState == 0 ? 'Network error, ready state 0' : 'Unknown error';
    const userErrorMessage = parsedBody.error?.message
        ? parsedBody.error?.message
        : `Sorry, there was an unexpected error (${fallbackError})`
    return {
        userErrorMessage,
        reason: parsedBody.error?.reason ? parsedBody.error?.reason : null,
        status: jqXHR.status,
        isUnauthorized: () => jqXHR.status === 401,
        isNotFound: () => jqXHR.status === 404,
    };
};

const LOMI_API_DEFAULT_HEADERS = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "X-Lomi-Client": "Web",
    "X-Lomi-Client-Version": "2.0.0",
}

const getLomiApiHeaders = (authToken) => {
    if (authToken) {
        return {
            ...LOMI_API_DEFAULT_HEADERS,
            'Authorization': `Bearer ${authToken}`,
        };
    }

    return LOMI_API_DEFAULT_HEADERS;
};
